var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('base-bread-crumb',{staticClass:"bg-white",attrs:{"items":_vm.breadcrumbs}})],1)],1),_c('form-micro-credential',{attrs:{"user":_vm.user,"fallback":_vm.fallbackRoute}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }